import { useState } from "react";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import ACL_RELATIONSHIPS from "acl-relationships";
import { checkIsAuthorized } from "components/helpers";
import { invalidateRevenueOpportunityStatusPresetsTableQuery } from "hooks/useRevenueOpportunityStatusPresetsTable";
import DeleteRevenueOpportunityStatusPresetModal from "routes/revenue_opportunity_status_presets/components/DeleteRevenueOpportunityStatusPresetModal";
import RevenueOpportunityStatusPresetModal from "routes/revenue_opportunity_status_presets/components/RevenueOpportunityStatusPresetModal";

export function RevenueOpportunityStatusPresetsTableActions({ original }) {
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const canEdit = checkIsAuthorized([
    ACL_RELATIONSHIPS.revenueOpportunityStatusPreset.edit,
    ACL_RELATIONSHIPS.revenueOpportunityStatus.read,
  ]);
  const canDelete = checkIsAuthorized([
    ACL_RELATIONSHIPS.revenueOpportunityStatusPreset.delete,
  ]);

  if (!canEdit && !canDelete) return null;

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          aria-label="Preset actions"
          className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
        >
          <Ellipsis />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {canEdit && (
            <DropdownMenuItem onClick={() => setEditOpen(true)}>
              <Pencil />
              Edit
            </DropdownMenuItem>
          )}
          {canDelete && (
            <DropdownMenuItem
              variant="destructive"
              onClick={() => setDeleteOpen(true)}
            >
              <Trash2 />
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      <RevenueOpportunityStatusPresetModal
        preset={original}
        open={editOpen}
        onOpenChange={setEditOpen}
        onSuccess={invalidateRevenueOpportunityStatusPresetsTableQuery}
      />
      <DeleteRevenueOpportunityStatusPresetModal
        preset={original}
        open={deleteOpen}
        onOpenChange={setDeleteOpen}
        onSuccess={invalidateRevenueOpportunityStatusPresetsTableQuery}
      />
    </>
  );
}
